export const MenuItems = [

  {
    title: 'จัดการผู้ใช้งาน',
    path: '/accountlist',
    cName: 'dropdown-link-custom'
  },
  {
    title: 'ประเภทอุปกรณ์',
    path: '/grouplist',
    cName: 'dropdown-link-custom'
  }
  ,
  {
    title: 'รายการอุปกรณ์',
    path: '/itemlist',
    cName: 'dropdown-link-custom'
  }
];
export const MenuItems2 = [
  {
    title: 'Scan QRCode',
    path: '/qrscan',
    cName: 'dropdown-link-custom'
  }
];
export const MenuItemReport = [
  {
    title: 'dashboard',
    path: '/dashboard',
    cName: 'dropdown-link-custom'
  },

  {
    title: 'รายงาน',
    path: '/report',
    cName: 'dropdown-link-custom'
  },
  {
    title: 'รายงานพร้อมรูปถ่าย',
    path: '/reportcheck',
    cName: 'dropdown-link-custom'
  },
 
];



